// extracted by mini-css-extract-plugin
export default {"icon-wrap":"dG9Qe"};